import { render, staticRenderFns } from "./DangerZoneFields.vue?vue&type=template&id=3d55f4df&lang=pug"
import script from "./DangerZoneFields.vue?vue&type=script&lang=js"
export * from "./DangerZoneFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports